import {
    ChangeDetectionStrategy,
    Component,
    computed, effect,
    ElementRef,
    inject,
    input,
    viewChild,
    ViewEncapsulation
} from '@angular/core';
import { AppNavGroup } from './nav-group';
import { LayoutService } from '../../../service/layout.service';
import { MatIconModule } from '@angular/material/icon';
import { animate, sequence, state, style, transition, trigger } from '@angular/animations';
import { ISbAsset } from '@seven1/model';
import { CmsComponent } from '@seven1/angular-storyblok-cms';
import { IImageBlock, ImageComponent } from '@seven1/angular-storyblok-components/image';

@Component({
    selector: 'nav[app-navigation]',
    imports: [CmsComponent, MatIconModule, ImageComponent],
    templateUrl: './navigation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        role: 'navigation',
    },
    animations: [
        trigger('sidebarAnimation', [
            state(
                'open',
                style({
                    transform: 'translateX(0)',
                    display: 'block',
                })
            ),
            state(
                'closed',
                style({
                    display: 'none',
                    transform: 'translateX(100%)',
                })
            ),
            transition('open => closed', [
                sequence([
                    animate(
                        '300ms ease-in',
                        style({
                            transform: 'translateX(100%)',
                        })
                    ),
                    animate(
                        '1ms',
                        style({
                            display: 'none',
                        })
                    ),
                ]),
            ]),
            transition('closed => open', [
                style({
                    display: 'block',
                    transform: 'translateX(100%)',
                }),
                animate(
                    '300ms ease-out',
                    style({
                        transform: 'translateX(0)',
                    })
                ),
            ]),
        ]),
    ],
})
export class NavigationComponent {
    public readonly baseClass: string = 'app-navigation';
    public layoutService = inject(LayoutService);
    menuClosingButtonRef = viewChild<ElementRef<HTMLButtonElement>>('menuClosingButton');
    nav_logo = input.required<ISbAsset[]>();
    nav_children = input.required<AppNavGroup[]>();

    logo = computed<IImageBlock | null>(() => {
        const logo = this.nav_logo();
        if (!logo?.length) {
            return null;
        }
        return {
            asset: logo[0],
            maxWidth: '8rem',
        };
    });

    constructor() {
        effect(() => {
            if (this.layoutService.navOpen()) {
                setTimeout(() => {
                    this.menuClosingButtonRef()?.nativeElement.focus();
                });
            }
        });
    }

    closeMenu() {
        this.layoutService.closeNav();
    }
}
